import { Tag } from 'antd'
import Flex from 'components/Flex'
import React from 'react'
import styled from 'styled-components'

const CustomTagBlue = styled(Tag)`
  border-radius: 20px;
  font-size: 10px;
  -webkit-box-align: center;
  align-items: center;
  max-width: max-content;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const CustomTagBlack = styled(Tag)`
  background-color: rgba(0, 0, 0, 1);
  border-radius: 20px;
  max-width: max-content;
  font-size: 10px;
  height: 20px;
  align-items: center;
`
const CustomTagAsh = styled(Tag)`
  background-color: rgba(143, 143, 143, 1);
  border-radius: 20px;
  font-size: 10px;
  height: 20px;
  align-items: center;
  max-width: max-content;
`

const TableTag = ({ Corp, ExTNL }) => (
  <Flex gap="4px" column>
    {Corp ? (
      <CustomTagBlue color="rgba(50, 73, 215, 1)">PIL</CustomTagBlue>
    ) : (
      <CustomTagAsh color="rgba(143, 143, 143, 1)">Dir.Corp. </CustomTagAsh>
    )}
    {ExTNL && <CustomTagBlack color="rgba(0, 0, 0, 1)">Extnl. </CustomTagBlack>}
  </Flex>
)
export default TableTag
